import { render, staticRenderFns } from "./DocumentPage.vue?vue&type=template&id=7d68a5ca&scoped=true&"
import script from "./DocumentPage.vue?vue&type=script&lang=js&"
export * from "./DocumentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d68a5ca",
  null
  
)

export default component.exports